import { FC, useState } from 'react';
import { LayoutCarousel } from '@silverfort/sf-components';
import { useAuthenticationTypeData } from './hooks/useAuthenticationTypeData';
import { AuthenticationType, AuthenticationTypeSummary } from '../../types';
import usePaginatedDonutChart from '../../hooks/usePaginatedDonutChart';

interface AuthenticationTypeChartProps {
    authenticationTypeSummary?: AuthenticationTypeSummary;
    isLoading: boolean;
    className?: string;
    onClick: (authenticationType: AuthenticationType) => void;
    innerCircleEmptyStateClassName?: string;
}

enum DropdownOption {
    MFA = 'mfa',
    ALL = 'all'
}

const AuthenticationTypeChart: FC<AuthenticationTypeChartProps> = ({
    authenticationTypeSummary,
    isLoading,
    className,
    onClick,
    innerCircleEmptyStateClassName = ''
}) => {
    const [selectedDropdownOption, setSelectedDropdownOption] = useState<DropdownOption>(DropdownOption.MFA);
    const relevantAuthTypeSummary =
        selectedDropdownOption === DropdownOption.MFA ? authenticationTypeSummary?.mfa : authenticationTypeSummary?.all;
    const chartData = useAuthenticationTypeData(onClick, relevantAuthTypeSummary);
    const pages = usePaginatedDonutChart({ chartData, isLoading, innerCircleEmptyStateClassName});

    return (
        <LayoutCarousel
            title="Authentication type"
            className={className}
            contentClassName={`flex flex-1 flex-col justify-center px-6 `}
            pages={pages}
            dropDownProps={{
                variant: 'trigger',
                items: [
                    { value: DropdownOption.MFA, title: 'MFA authentications' },
                    { value: DropdownOption.ALL, title: 'All authentications' }
                ],
                size: 'large',
                width: '160px',
                className: '[&]:w-[160px] border [&]:border-sf-gray-100 bg-transparent',
                selectedItems: selectedDropdownOption,
                onChange: (value) => setSelectedDropdownOption(value as DropdownOption)
            }}
        />
    );
};

export default AuthenticationTypeChart;
